var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconToolActive = function SvgIconToolActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: 1.25,
    d: "M21.58 23.82c0 .27-.142.598-.551.968s-1.037.732-1.866 1.05c-1.653.632-3.978 1.036-6.578 1.036s-4.926-.404-6.58-1.037c-.828-.317-1.456-.679-1.865-1.049s-.55-.698-.55-.968.14-.599.55-.969 1.037-.732 1.866-1.049c1.653-.632 3.978-1.036 6.579-1.036s4.925.404 6.578 1.036c.829.317 1.456.679 1.866 1.05.41.37.55.698.55.968Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A326D",
    stroke: "inherit",
    d: "M12.412 19.586a.625.625 0 1 1-1.082-.625zm-1.082-.625 5-8.66 1.082.625-5 8.66z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.375,
    stroke: "inherit",
    strokeWidth: 1.25,
    transform: "scale(-1 1)rotate(-30 -3.613 50.805)"
  })));
};
export default SvgIconToolActive;